import { Controller } from "@hotwired/stimulus"
import findInteractiveElements from "../utilities/find_interactive_elements"

// Connects to data-controller="map-overlay"
export default class extends Controller {

  focus(event) {
    const focusables = Array.from(findInteractiveElements(event.target))
                          .filter(el => !el.hasAttribute('disabled') && this.#isVisible(el));

    if (focusables.length > 0) {
      focusables[0].focus();
    }
  }

  #isVisible(element) {
    return !!element.offsetParent && !element.hidden && getComputedStyle(element).visibility !== 'hidden';
  }
}